import React, { useState, useEffect } from "react";
import { Col, Modal, Form, InputGroup, Row } from "react-bootstrap";
import "./add-affiliates.css";
import DataTable from "react-data-table-component";
import validator from "validator";
import axios from "../../../axios/axios";
import { MultiSelect } from "react-multi-select-component";
import { saveCommissionPlan } from "../../../axios/affiliate.axios";
import LoadingOverlay from "react-loading-overlay";
import { productsPlan } from "./plan-products";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  footer: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  pagination: {
    container: {
      backgroundColor: "#004aad",
      color: "#fff",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#fff",
      //backgroundColor: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const CommissionPlan = () => {
  const [clickCount, setClickCount] = useState(0);
  const [isParentDivVisible, setParentDivVisibility] = useState(true);
  const [corpoUser, setcorpoUser] = useState([]);
  const [optionUser, setoptionUser] = useState([]);
  const [selected, setSelected] = useState([]);
  const [stateChange, setStateChange] = useState(false);
  const [commisionPlanList, setcommisionPlanList] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validMSG, setvalidMSG] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    site_name: "",
    plan_name: "",
    product: "",
    type: "",
    percentage: "",
  });

  const [input, setInput] = useState({
    site_name: "",
    plan_name: "",
    product: "",
    type: "",
    is_default: false,
    user_corporate: [],
    percentage: [],
  });

  const isNotEmpty = (string) => {
    return !validator.isEmpty(string);
  };

  const handleButtonClick = () => {
    setClickCount(clickCount + 1);
    setParentDivVisibility(true);
  };
  const handleRemoveParentDiv = () => {
    //setdivCount(key)
    setClickCount(0);
    setParentDivVisibility(false);
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const renderDivs = () => {
    const divs = [];
    for (let i = 0; i < clickCount; i++) {
      divs.push(
        <div key={i}>
          {isParentDivVisible && (
            <div className="cmn_name_group">
              <InputGroup className="mb-3">
                {/* <Form.Control
            as="select"
            className="tier_index1"
            name="tier_index"
            onChange={(event) => { handleInputchange(event) }}
          >
            <option value="">Select Tier Index</option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
          </Form.Control> */}
                <label className="mr-2 mt-2">Tier {i + 2}</label>
                <Form.Control
                  placeholder="Tier Percentage"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  className="tier_index1"
                  type="number"
                  name="tier_percentage"
                  onChange={(event) => {
                    handleInputchange(event);
                  }}
                />
                {/* <InputGroup.Text id="basic-addon1">+</InputGroup.Text> */}
              </InputGroup>
              <button type="button" onClick={handleRemoveParentDiv}>
                -
              </button>
            </div>
          )}
        </div>
      );
    }
    return divs;
  };

  const handleInputchange = (event) => {
    if (
      event.target.name !== "tier_index" &&
      event.target.name !== "tier_percentage"
    ) {
      setInput({
        ...input,
        [event.target.name]: event.target.value,
      });
    }

    if (event.target.name == "is_default") {
      var lfckv = document.getElementById("html").checked;

      setInput({
        ...input,
        ["is_default"]: lfckv,
      });
    }

    if (event.target.name == "type") {
      if (event.target.value == "corporate") {
        getMembers(input.site_name);
      } else {
        setcorpoUser([]);
      }
    }

    if (isNotEmpty(event.target.value)) {
      setErrorMessage({
        ...errorMessage,
        [event.target.name]: "",
      });
    } else {
      setErrorMessage({
        ...errorMessage,
        [event.target.name]: "Please add some text",
      });
    }
  };

  const handleButtonClickSubmit = async () => {
    let vrows = document.getElementsByName("tier_percentage");
    var totalPercentage = [];

    vrows.forEach((element_data) => {
      if (element_data.value != "") {
        totalPercentage.push(element_data.value);
      }
    });
    setStateChange(false);

    setTimeout(async () => {
      await updateStateCall(totalPercentage);
    }, 2000);

    if (
      input.plan_name == "" &&
      input.product == "" &&
      input.site_name == "" &&
      input.type == ""
    ) {
      setvalidMSG(true);
    }
  };

  const updateStateCall = async (totalPercentage) => {
    let selectedData = [];
    if (selected.length > 0) {
      selected.forEach((element) => {
        selectedData.push(element.value);
      });
      setStateChange(true);
    }
    setInput({
      ...input,
      user_corporate: selectedData,
      percentage: totalPercentage,
    });
  };

  const getMembers = (source) => {
    setLoading(true);
    axios
      .get(`/user/get-corporate-users/${source}`, adminConfig())
      .then((res) => {
        setcorpoUser(res.data.message);
        let options = [];
        res.data.message.map((user, i) => {
          // console.log("certt--", cert);
          let obj = { label: user.email, value: user.id };
          options.push(obj);
        });

        setoptionUser(options);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getList = () => {
    setLoading(true);
    axios
      .get(`/commission-plan-list`, adminConfig())
      .then((res) => {
        setcommisionPlanList(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const modalopenForView = (id) => {
    setLoading(true);
    axios
      .get(`/commission-plan-details/${id}`, adminConfig())
      .then((res) => {
        setViewData(res.data.data);
        handleShow();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const deletePlan = (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Do you want to delete?")) {
      setLoading(true);
      axios
        .get(`/commission-plan-delete/${id}`, adminConfig())
        .then((res) => {
          getList();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    if (input.percentage.length > 0) {
      try {
        setLoading(true);
        setTimeout(async () => {
          await saveCommissionPlan(undefined, input);
          getList();
          setInput({
            ...input,
            site_name: "",
            plan_name: "",
            product: "",
            type: "",
            is_default: false,
            user_corporate: [],
            percentage: [],
          });
          document.getElementById("create_plan_form").reset();
          handleRemoveParentDiv();
          setSelected([]);
          setLoading(false);
          setvalidMSG(false);
        }, 1000);
      } catch (error) {
        setLoading(false);
      }
    }
  }, [input]);

  const columns = [
    {
      name: "Affiliate Type",
      selector: (row) => row.affiliateType,
      sortable: true,
      width: "400px",
    },
    {
      name: "Plan Name",
      selector: (row) => row.name,
      sortable: true,
      width: "400px",
    },
    {
      name: "Action",
      selector: (row) => {
        return (
          <div className="edit_delete_but">
            <button
              type="button"
              className="edit_buttt butttton"
              onClick={() => modalopenForView(row._id)}
            >
              View More
            </button>
            <button
              type="button"
              className="delete_buttt butttton"
              onClick={() => deletePlan(row._id)}
            >
              Delete
            </button>
          </div>
        );
      },
      sortable: true,
      width: "400px",
    },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="add_plan">
                  <form id="create_plan_form">
                    {validMSG ? (
                      <>
                        <p className="text-danger text-center">
                          Fill the form correctly
                        </p>
                      </>
                    ) : (
                      <></>
                    )}
                    <Row>
                      <Col lg="10" md="8" sm="12">
                        <Form.Group
                          controlId="formBasicSelect"
                          className="cmn_name"
                        >
                          <Form.Label>Site Name</Form.Label>
                          <Form.Control
                            as="select"
                            className="select_control"
                            name="site_name"
                            onChange={(event) => {
                              handleInputchange(event);
                            }}
                          >
                            <option value="tv" selected>
                              Tripvalet
                            </option>
                            <option value="tvi">Tripvalet Incentive</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col lg="2" md="4" sm="12">
                        <div className="form-group1 d-flex mt-4 pt-3">
                          <input
                            type="checkbox"
                            id="html"
                            name="is_default"
                            onChange={(event) => {
                              handleInputchange(event);
                            }}
                          />
                          <label for="html">Is Default</label>
                        </div>
                      </Col>
                      <Col lg="10" md="8" sm="12">
                        <Form.Group
                          controlId="formBasicSelect"
                          className="cmn_name"
                        >
                          <Form.Label>Plan Name</Form.Label>
                          <Form.Control
                            placeholder="Plan Name"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            className="tier_index"
                            type="text"
                            name="plan_name"
                            onChange={(event) => {
                              handleInputchange(event);
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    {input.site_name == "tvi" ? (
                      <>
                        <Form.Group
                          controlId="formBasicSelect"
                          className="cmn_name"
                        >
                          <Form.Label>Select Products</Form.Label>
                          <Form.Control
                            as="select"
                            className="select_control"
                            name="product"
                            onChange={(event) => {
                              handleInputchange(event);
                            }}
                          >
                            <option value="">Select Products</option>
                            {productsPlan["tvi"].map((tviP) => (
                              <option value={tviP.id}>{tviP.name}</option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </>
                    ) : (
                      <>
                        <Form.Group
                          controlId="formBasicSelect"
                          className="cmn_name"
                        >
                          <Form.Label>Select Products</Form.Label>
                          <Form.Control
                            as="select"
                            className="select_control"
                            name="product"
                            onChange={(event) => {
                              handleInputchange(event);
                            }}
                          >
                            <option value="">Select Products</option>
                            {productsPlan["tv"].map((tvP) => (
                              <option value={tvP.id}>{tvP.name}</option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}

                    <Form.Group
                      controlId="formBasicSelect"
                      className="cmn_name"
                    >
                      <Form.Label>Affiliate Type</Form.Label>
                      <Form.Control
                        as="select"
                        className="select_control"
                        name="type"
                        onChange={(event) => {
                          handleInputchange(event);
                        }}
                      >
                        <option value="">Select Type</option>
                        <option value="individual">Individual</option>
                        <option value="corporate">Corporate</option>
                      </Form.Control>
                    </Form.Group>
                    {input.type == "corporate" ? (
                      <>
                        <Form.Group
                          controlId="formBasicSelect"
                          className="cmn_name"
                        >
                          <Form.Label>Corporate User Select</Form.Label>

                          <MultiSelect
                            name="user_corporate"
                            options={optionUser}
                            value={selected}
                            onChange={setSelected}
                            labelledBy={""}
                          />
                        </Form.Group>
                      </>
                    ) : (
                      <></>
                    )}

                    <Form.Group
                      controlId="formBasicSelect"
                      className="cmn_name"
                    >
                      <Form.Label>Tier Percentage</Form.Label>
                      {/* <Form.Control
                          as="select"
                          className="select_control"
                        >
                          <option value="DICTUM">Select Percentage</option>
                          <option value="DICTUM">Type A</option>
                          <option value="CONSTANCY">Type B</option>
                          <option value="COMPLEMENT">Type C</option>
                        </Form.Control> */}
                      <div className="cmn_name_group">
                        <InputGroup className="mb-3">
                          {/* <Form.Control
                        as="select"
                        className="tier_index1"
                        name="tier_index"
                      >
                        <option value="">Select Tier Index</option>
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                      </Form.Control> */}
                          <label className="mr-2 mt-2">Tier 1</label>
                          <Form.Control
                            placeholder="Tier Percentage"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            className="tier_index1"
                            type="number"
                            name="tier_percentage"
                            onChange={(event) => {
                              handleInputchange(event);
                            }}
                          />
                          {/* <InputGroup.Text id="basic-addon1">+</InputGroup.Text> */}
                        </InputGroup>
                        <button type="button" onClick={handleButtonClick}>
                          +
                        </button>
                      </div>
                      {renderDivs()}
                    </Form.Group>

                    <button
                      type="button"
                      className="add_plan_but"
                      onClick={handleButtonClickSubmit}
                    >
                      Add
                    </button>
                  </form>
                </div>
                <h2>Commission Plan List</h2>
                <div className="plan_data">
                  <DataTable
                    columns={columns}
                    data={commisionPlanList}
                    pagination
                    //customStyles
                    striped
                    responsive
                    customStyles={customStyles}
                    // onRowClicked={handleRowClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="m-0">
              <Col>
                <strong>Affliate Type :</strong>
              </Col>
              <Col>
                <p className="textwrap">{viewData.affiliateType}</p>
              </Col>
            </Row>
            <Row className="m-0">
              <Col>
                <strong>isDefault :</strong>
              </Col>
              <Col>
                <p className="textwrap">{viewData.isDefault ? "Yes" : "No"}</p>
              </Col>
            </Row>
            <Row className="m-0">
              <Col>
                <strong>Plan Name :</strong>
              </Col>
              <Col>
                <p className="textwrap">{viewData.name}</p>
              </Col>
            </Row>
            <Row className="m-0">
              <Col>
                <strong>Structure :</strong>
              </Col>
              <Col>
                {viewData.structure ? (
                  <>
                    {viewData.structure.map((element) => (
                      <p className="textwrap">
                        Tier : {element.level} , Percentage : {element.value} %
                      </p>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
            {/* {(viewData.affiliateType == 'corporate') ? (<>
              <Row className="m-0">
                <Col>
                  <strong>
                    Corporate Users :
                  </strong>
                </Col>
                <Col>
                  {viewData.user_corporate.map((element1) => (
                  <p className="textwrap">{element1}</p>
                ))}
                </Col>
              </Row>
            </>) : (<></>)} */}
          </Modal.Body>
        </Modal>
      </div>
    </LoadingOverlay>
  );
};
export default CommissionPlan;
